﻿// needs data from server represented in an i18n variable 
import React from "react";

class PressImages extends React.Component {
    render() {
        if (!this.props.data) return null;

        return (
            <div className={"onerow"}>
                <div className={"col12 last"}>
                    <hr />
                    <div dangerouslySetInnerHTML={{__html: this.props.data}} />
                </div>
            </div>
        );
    }
}

export default PressImages;